/** @jsx isolateComponent */

import { useState } from 'react';
import { css, keyframes } from '@emotion/react';
import { TrialHub } from '@zapier/trials';
import { Button, Colors } from '@zapier/design-system';
import { useLocalStorage } from '@zapier/common-hooks';
import { isolateComponent } from '@zapier/style-encapsulation';

import type { Account } from '@zapier/trials';

// Copied from editor repo
const borderPulseKeyframes = keyframes`
  from {
    border-color: ${Colors.transparent};
    top: -2px;
    bottom: -2px;
    left: -2px;
    right: -2px;
  }
  50% {
    border-color: ${Colors.brand};
  }
  to {
    border-color: ${Colors.transparent};
    top: -5px;
    bottom: -5px;
    left: -5px;
    right: -5px;
  }
`;

const trialHubHighlightStyles = css`
  button#trial-hub-toggle-button {
    border-color: ${Colors.brand};

    &::before {
      animation: ${borderPulseKeyframes} 1s ease-in-out infinite;
    }
  }
`;

const UniversalSidebarTrialHub = ({
  builderApiKey,
  account,
}: {
  builderApiKey: string;
  account: Account;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [trialHubSeen, setTrialHubSeen] = useLocalStorage('trialHubSeen');

  const onButtonClick = () => {
    setIsOpen(true);
    setTrialHubSeen(true);
  };

  return (
    <div
      css={trialHubSeen ? undefined : trialHubHighlightStyles}
      data-testid={
        trialHubSeen ? 'trial-hub-button-default' : 'trial-hub-button-highlight'
      }
    >
      <Button
        color="secondary"
        isFullWidth={true}
        size="small"
        onClick={onButtonClick}
        id="trial-hub-toggle-button"
      >
        Explore trial features
      </Button>
      {isOpen && (
        <TrialHub
          account={account}
          builderApiKey={builderApiKey}
          onClose={() => setIsOpen(false)}
        />
      )}
    </div>
  );
};

export default UniversalSidebarTrialHub;
